import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import SaveToListQuotaTooltipContent from "./SaveToListQuotaTooltipContent";

type I18nKeyModifier = "account" | "company" | "company-structure";

type Props = {
    isOutOfQuota: boolean;
    i18nKeyModifier: I18nKeyModifier;
    quotaI18nKeyModifier?: I18nKeyModifier;
};

const SaveToListTooltipContent = ({ isOutOfQuota, i18nKeyModifier, quotaI18nKeyModifier }: Props) => {
    if (isOutOfQuota) {
        return <SaveToListQuotaTooltipContent i18nKeyModifier={quotaI18nKeyModifier ?? i18nKeyModifier} />;
    }

    return <I18n translatable={{ key: `si.save-to-list.${i18nKeyModifier}.button.tooltip` }} />;
};

export default SaveToListTooltipContent;
